// NOTE: Safe area is already handled by the native app with <SafeAreaView>, this was broken previously in the native app.
// Leaving this here in case we decide to add padding uniformly across the app or if the native app
// breaks/ is outdated again.

import { log } from '@/utils/logger'
import { getNativeAppVersion } from './nativeAppVersionUtil'

const VERSION_WHERE_SAFE_AREA_IS_DETERMINED_BY_NATIVE_APP = 195

export const getSafeAreaPaddingTop = () => {
    const nativeAppVersion = getNativeAppVersion()

    if (nativeAppVersion && nativeAppVersion < VERSION_WHERE_SAFE_AREA_IS_DETERMINED_BY_NATIVE_APP) {
        log.info('Safe area padding top is 8 since version number is %{nativeAppVersion}', { nativeAppVersion })
        return Math.max(window?.safeAreaInsetTop ?? 8, 8)
    } else {
        log.info('Safe area padding top is 0 since version number is %{nativeAppVersionStr}', { nativeAppVersionStr: nativeAppVersion?.toString() })
        return 0
    }
}

export const getSafeAreaPaddingBottom = () => {
    const nativeAppVersion = getNativeAppVersion()

    if (nativeAppVersion && nativeAppVersion < VERSION_WHERE_SAFE_AREA_IS_DETERMINED_BY_NATIVE_APP) {
        log.info('Safe area padding bottom is 8 since version number is %{nativeAppVersion}', { nativeAppVersion })
        return Math.max(window?.safeAreaInsetBottom ?? 8, 8)
    } else {
        log.info('Safe area padding bottom is 0 since version number is %{nativeAppVersionStr}', { nativeAppVersionStr: nativeAppVersion?.toString() })
        return 0
    }
}
